
export type StatusParamParameter = typeof StatusParamParameter[keyof typeof StatusParamParameter];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StatusParamParameter = {
  ALL: 'ALL',
  PUBLISHED: 'PUBLISHED',
  DRAFT: 'DRAFT',
} as const;
